export default {
    'ERROR-CREATE-REVIEW-SETTINGS': {
        'REVIEW-REQUEST-ALREADY-EXISTS': {
            actionType: 'toast',
            message: {
                fr: "Une demande de revue existe déjà pour cette organisation.",
                en: 'A review request already exists for this organization.',
            },
        },
        'CONTACT-ADMIN-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "L'administrateur de contact spécifié est introuvable.",
                en: 'The specified contact admin could not be found.',
            },
        },
        'SHORT-URL-NOT-CREATED': {
            actionType: 'toast',
            message: {
                fr: "Le lien court n'a pas pu être créé.",
                en: 'The short URL could not be created.',
            },
        },
    },
    'ERROR-ADD-REVIEW-RECIPIENTS-ADMIN': {
        'RECIPIENTS-TYPE-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Le type de destinataires est introuvable.",
                en: 'Recipients type not found.',
            },
        },
        'REVIEW-REQUEST-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Demande de revue non trouvée pour cette organisation.",
                en: 'Review request not found for this organization.',
            },
        },
        'RECIPIENTS-INVALID': {
            actionType: 'toast',
            message: {
                fr: "Les destinataires fournis ne sont pas valides.",
                en: 'The provided recipients are invalid.',
            },
        },
        'USERS-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Certains utilisateurs spécifiés sont introuvables.",
                en: 'Some specified users could not be found.',
            },
        },
        'RECIPIENTS-NOT-UNIQUE': {
            actionType: 'toast',
            message: {
                fr: "Les emails des destinataires ne sont pas uniques.",
                en: 'Recipients emails are not unique.',
            },
        },
        'RECIPIENTS-NOT-VALID': {
            actionType: 'toast',
            message: {
                fr: "Les emails des destinataires ne sont pas valides.",
                en: 'Recipients emails are not valid.',
            },
        },
    },
};
